import Table from "./TableNode";
import Headers from "./Headers";
import Body from "./Body";
import Item from "./Item";
import Cell from "./Cell";
import Value from "./Value";
import TableRowsNode from "./TableRowsNode";
const tableRegistry: any = {
    table: Table,
    headers: Headers,

    body: Body,
    item: Item,
    cell: Cell,

    value: Value,
    table_rows: TableRowsNode,
};

export default tableRegistry;